import React, { useEffect, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery } from '@mui/material';


const SOIssueView = () => {
    const [formData, setFormData] = useState([]);
    const isDesktop = useMediaQuery('(min-width:768px)');
    // useEffect(() => {
    //     // Retrieve the URL parameters
    //     const query = new URLSearchParams(window.location.search);
    //     const formParam = query.get('form');

    //     if (formParam) {
    //         try {
    //             // Parse the form data
    //             const parsedForm = JSON.parse(decodeURIComponent(formParam));
    //             setFormData(parsedForm);
    //         } catch (error) {
    //             console.error('Error parsing form data:', error);
    //         }
    //     }
    // }, []);

    useEffect(() => {
        const stored = localStorage.getItem("SOViewData");
        if (stored) {
            const data = JSON.parse(stored);
            setFormData(data); // set state to use in UI
        }
    }, []);


    console.log(formData)
    return (
        <>

            <Grid container>
                <Grid item>
                    <Paper style={{ padding: '2vh' }}>
                        <div style={{ margin: '1% 0%', width: '100%' }}>

                            <h3 className='centered-heading'>Sale Order View</h3>
                            <div className="dashed-line"></div>

                            <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                                <tbody>

                                    <tr>
                                        <td style={{ width: '200px' }}>Item Name</td>
                                        <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{formData.itemNm}</td>
                                        <td style={{ width: '200px', paddingLeft: '2%' }}>Quotation</td>
                                        <td style={{ padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.quotationNo}</td>
                                    </tr>

                                    <tr>
                                        <td style={{ width: '200px' }}>Total Qty.</td>
                                        <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.totqty}</td>
                                        {/* <td style={{ width: '200px', paddingLeft: '2%' }}>Extra</td>
                                        <td style={{ width: '30vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.extra}</td> */}
                                    </tr>

                                </tbody>
                            </table>


                            <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                                <tbody>
                                    <tr>
                                        <td>Size</td>
                                        {formData?.size?.map((item) => (
                                            <td key={item}>{item}</td>
                                        ))}
                                    </tr>
                                    <tr>
                                        <td>Rate</td>
                                        {formData?.rate?.map((item) => (
                                            <td key={item}>{item}</td>
                                        ))}
                                    </tr>
                                    <tr>
                                        <td>Qty.</td>
                                        {formData?.qty?.map((item) => (
                                            <td key={item}>{item}</td>
                                        ))}
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </Paper>
                </Grid>
            </Grid>
        </>
    );
};

export default SOIssueView;
